import React from 'react';
import { LiveContentDayReportContextProvider } from './contexts/LiveContentDayReportContext';
import { ReportPanel } from './ReportPanel';
import { SelectionPanel } from './SelectionPanel';

const pageStyle = {
    position: 'absolute',
    boxSizing: 'border-box',
    left: 130,  // hard-coding absolute position allowing for banner across top & selection menu at left - not great layout!! but works for now
    right: 50,
    top: 52,
    bottom: 36,
    display: 'flex',
    flexDirection: 'column',
    rowGap: 24,
    padding: '18px 24px'
}

export const LiveContentDayReportPage = () => {
    return (
        <LiveContentDayReportContextProvider>
            <div style={pageStyle}>
                <SelectionPanel />
                <ReportPanel />
            </div>
        </LiveContentDayReportContextProvider>
    );
}